import { render, staticRenderFns } from "./FormSendEmail.vue?vue&type=template&id=7180d2bc&scoped=true&"
import script from "./FormSendEmail.vue?vue&type=script&lang=js&"
export * from "./FormSendEmail.vue?vue&type=script&lang=js&"
import style0 from "./FormSendEmail.vue?vue&type=style&index=0&id=7180d2bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7180d2bc",
  null
  
)

export default component.exports